'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function HeroTitle({ tag = 'h1' }) {
  return h('.hero-title', [
    h('.page-container', [
      h('.row', [
        h('.hero-title-inner.twelve.columns', [
          h(
            Translate,
            { tag, attrs: { class: 'hero-title-text' } },
            'js.modules.shared.HeroTitle'
          ),
        ]),
      ]),
    ]),
  ]);
}

module.exports = HeroTitle;
